import { render, staticRenderFns } from "./DocumentPreviewPane.vue?vue&type=template&id=c5a5b6be&scoped=true&lang=pug"
import script from "./DocumentPreviewPane.vue?vue&type=script&lang=js"
export * from "./DocumentPreviewPane.vue?vue&type=script&lang=js"
import style0 from "./DocumentPreviewPane.vue?vue&type=style&index=0&id=c5a5b6be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a5b6be",
  null
  
)

export default component.exports